const programacion = {
    ObtenerAudienciasProgramadas: 'AudienciasTemporal/ProgramacionAudiencias/Programacion/ObtenerAudienciasProgramadas',
    GuardarProgramacionDeAudiencias: 'AudienciasTemporal/ProgramacionAudiencias/Programacion/GuardarProgramacionDeAudiencias',
    EliminarProgramacionDeAudiencias: 'AudienciasTemporal/ProgramacionAudiencias/Programacion/EliminarProgramacionDeAudiencias',
    ObtenerAudienciasDeJuez: 'AudienciasTemporal/ProgramacionAudiencias/Programacion/ObtenerAudienciasDeJuez',
    ObtenerAudienciasParaAdministracion: 'AudienciasTemporal/ProgramacionAudiencias/Programacion/ObtenerAudienciasParaAdministracion',
    ObtenerExcelListaAudiencias: 'AudienciasTemporal/ProgramacionAudiencias/Administracion/ObtenerExcelListaAudiencias'
};

const consultaJuez = {
    ObtenerListaDeAudienciasExcel: 'Audiencias/ConsultaJuez/ObtenerListaDeAudienciasExcel'
}

const programacionAudiencias = {
    programacion: programacion,
    consultaJuez: consultaJuez
};

export default programacionAudiencias;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/AudienciasTemporal/sistema/programacionDeAudiencias/ProgramacionDeAudienciasTemporal.js
// module id = null
// module chunks = 